import { useEffect, useState } from 'react';

/**
 * Si el dispositivo tiene un puntero capaz de hacer hover.
 *
 * POR QUÉ `(hover: hover)` Y NO EL ANCHO DE PANTALLA
 * El ancho no dice nada sobre el puntero. Una tablet conectada a un teclado con
 * mouse tiene 1024px y sí hace hover; un notebook táctil de 1440px puede estar
 * usándose con el dedo. Preguntar por el ancho para decidir si mostrar algo al
 * pasar el mouse es preguntar por una cosa esperando la respuesta de otra, y
 * falla justo en los equipos híbridos, que son cada vez más.
 *
 * `(hover: hover)` es la consulta que responde exactamente eso. El repo ya la usa
 * en CSS —`[@media(hover:hover)]` en EditableServiceCard—, así que este hook es
 * la misma pregunta desde JavaScript, para los casos en que no alcanza con CSS
 * porque hay que renderizar cosas distintas y no sólo esconderlas.
 *
 * Arranca en `true` a propósito: en el primer render todavía no se consultó
 * nada, y suponer escritorio deja el gráfico completo, que es lo que la mayoría
 * va a ver. Suponer táctil mostraría los botones un instante y desaparecerían.
 */
export default function useTieneHover() {
  const [tiene, setTiene] = useState(true);

  useEffect(() => {
    // En un entorno sin `matchMedia` —un render de servidor, una prueba— se
    // queda con el valor inicial en vez de romperse.
    if (typeof window === 'undefined' || !window.matchMedia) return undefined;

    const consulta = window.matchMedia('(hover: hover)');
    setTiene(consulta.matches);

    // Se escucha el cambio porque el puntero puede aparecer o irse en caliente:
    // enchufar un mouse a una tablet, o desacoplar la pantalla de un convertible.
    const alCambiar = (e) => setTiene(e.matches);
    consulta.addEventListener('change', alCambiar);
    return () => consulta.removeEventListener('change', alCambiar);
  }, []);

  return tiene;
}
